module.exports = __webpack_public_path__ + "img/trash-button.3d76a99b.svg";